import DataSource from "devextreme/data/data_source";
import { useQuery } from "react-query";
import { atom, atomFamily } from "recoil";
import { loadFn, Params } from "shared/component/dxf-map/dxf-map";
import { client } from "shared/helpers/client";
import moment from "moment";



export const getBalanceOffice=(params: Params)=> {
  return client<any[]>('/OwnerBooking/GetOfficeBalance', { params })
}

export const BalanceOfficeSource = (officeId: number) => {
  let searchTerm: any = {
    StartDate: { operator: "Equals", value: moment().subtract(30, 'days').startOf('day').format() },
    EndDate: { operator: "Equals", value: moment().format() }
  };

  return new DataSource({
    key:"id",
    load: async (options) => {
      const filter = options.searchValue;
      if (filter && Array.isArray(filter)) {
        filter.forEach((f: any) => {
          if (Array.isArray(f)) {
            if (f[0] === "StartDate") searchTerm.StartDate = { operator: "Equals", value: f[2] };
            if (f[0] === "EndDate") searchTerm.EndDate = { operator: "Equals", value: f[2] };
          }
        });
      }

      const { response, error }: any = await client('/OwnerBooking/GetOfficeBalance', {
        params: {
          officeId,
          searchTerm: JSON.stringify(searchTerm),
          skipCount: options.skip ?? 0,
          maxResultCount: options.take ?? 0,
        }
      });

      if (error) throw error;
      return { data: response?.data || [], totalCount: response?.totalCount ?? 0 };
    }
  });
}

  export const BalanceOfficeSourceAtom = atomFamily({
    key: 'BalanceOfficeSource',
    default: (officeId: any) => BalanceOfficeSource(officeId),
    dangerouslyAllowMutability:true
    })
    